import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import { EmptyWebsiteQueryBar } from "app/components/compare/WebsiteQueryBar/EmptyWebsiteQueryBar";
import { EducationContainer } from "app/components/educationbar/educationContainer";
import educationHook from "app/components/educationbar/educationHook";
import PageTitle from "app/components/React/PageTitle/PageTitle";
import { ProjectCreation } from "app/modules/project-from-comparison/ProjectCreation";

import WebsiteQueryBar from "../../../components/compare/WebsiteQueryBar/WebsiteQueryBar";
import { SubNav } from "../../../components/sub-navigation-bar/SubNav";

type WebsiteTechnologiesSubNavProps = {
    numberOfComparedItems: number;
};

export const WebsiteTechnologiesSubNav = ({ numberOfComparedItems }: WebsiteTechnologiesSubNavProps) => {
    const [showEducationIcon, showEducationBar, setValues] = educationHook();

    const { params } = useCurrentStateAndParams();
    const { isPersistent } = useSelector((state) => state.QueryBarReducer);
    const onEducationIconClick = () => {
        setValues(false, true);
    };

    const onCloseEducationBar = () => {
        setValues(true, false);
    };

    return isPersistent ? (
        <SubNav
            topLeftComponent={<EmptyWebsiteQueryBar />}
            bottomLeftComponent={<PageTitle />}
        />
    ) : params.key?.length ? (
        <SubNav
            topLeftComponent={
                <>
                    <WebsiteQueryBar />
                    <ProjectCreation />
                </>
            }
            numberOfComparedItems={numberOfComparedItems}
            bottomLeftComponent={
                <PageTitle
                    showEducationIcon={showEducationIcon}
                    onEducationIconClick={onEducationIconClick}
                />
            }
            education={showEducationBar ? <EducationContainer onCloseEducationComponent={onCloseEducationBar} /> : null}
        />
    ) : null;
};
